<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html{
  overflow: hidden;
}
body{
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue